<div class="featured">
	<picture>
		<source media="(min-width: 768px)" [srcset]="image" *ngIf="image">
		<img [src]="cover" *ngIf="cover">
	</picture>

	<div class="gradient"></div>

	<div class="featured-info-wrapper">
		<ng-content select=".featured-info"></ng-content>
	</div>
	<ng-content select=".slider"></ng-content>
</div>